module.exports = __webpack_public_path__ + "static/img/C4D0004.6d9c8bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0004.jpg
// module id = VEF3
// module chunks = 0